import tw from 'twin.macro';

export const HighlightedText = tw.span`rounded-3xl bg-primary-500 text-gray-100 px-4 transform -skew-x-12 inline-block`;
